var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconNavigation = function SvgIconNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.863 10.972.386.778A.333.333 0 0 1 .832.364l.115-.27-.115.27L10.61 4.53a.333.333 0 0 1-.016.62L6.831 6.525a1 1 0 0 0-.568.528l.304.137-.304-.137-1.78 3.947a.333.333 0 0 1-.62-.029Z",
    stroke: "currentColor",
    strokeWidth: 0.667
  })));
};
export default SvgIconNavigation;